import { combineReducers } from "redux";

import app from "./app/appReducers";
import blog from "./blog/blogReducers";

export default combineReducers({
    appData: app,
    blogData: blog
});
